import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ClaimsService } from '@app/services/claims/claims.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { MemberService } from '@app/services/member.service';
import { UserService } from '@app/services/user/user.service';
import { DialogService } from '@app/services/shared/dialog.service';
import { SnackbarService } from '@app/services/shared/snackbar.service';
import { Router } from '@angular/router';
import { ConfirmDialogModel, ConfirmdialogComponent } from '@app/components/shared/dialog/confirmdialog/confirmdialog.component';
import { MailService } from '@app/services/shared/mail.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { OidcSecurityService } from "angular-auth-oidc-client";
// custom validator to check that two fields match
export function MustMatch(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      // return if another validator has already found an error on the matchingControl
      return;
    }

    // set error on matchingControl if validation fails
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ mustMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}

interface User {
  id: number;
  givenname: string;
  familyname: string;
  email: string;
}

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.css']
})

export class ChangepasswordComponent implements OnInit, OnDestroy {
  form;
  displayCancelDialog = false;
  id: number;
  subscriptions: Subscription[] = [];
  viewmembersearch = false;
  _routeparamsSubscription: Subscription;
  loggedinuser: User;
  actualmember: User;
  displayPasswordRules = false;
  showemail = false;
  changepassword = false;
  displayInfoDialog = false;

  constructor(
    private oidcSecurityService: OidcSecurityService,
    private fb: FormBuilder,
    private mailService: MailService,
    private dialogService: DialogService,
    private router: Router,
    private snackbarService: SnackbarService,
    private dialog: MatDialog,
    private claimsService: ClaimsService,
    private route: ActivatedRoute,
    private memberService: MemberService,
    private userService: UserService,
  private confirmationService: ConfirmationService,
private messageService: MessageService) { }

  ngOnInit() {
    this.form = this.fb.group({
      currentPassword: ['', null],
      password: ['', Validators.required],
      passwordConfirmation: ['', Validators.required],
      email: [false, '']
    }, { validator: MustMatch('password', 'passwordConfirmation') });
    const claims = this.claimsService.claims$.getValue();
    this.loggedinuser = { id: claims?.id, givenname: claims?.givenName, familyname: claims?.familyName, email: claims?.email };
    this.subscriptions.push(this._routeparamsSubscription = this.route.params.subscribe(async params => {
      this.form.reset();
      this.id = Number(params['id']);
      if (this.id) {
        this.memberService.getMemberById(this.id).subscribe(data => {
          this.actualmember = { id: this.id, givenname: data.givenName, familyname: data.familyName, email: data.email };
        });
      } else {
        this.viewmembersearch = true;
      }
    }));
    if(this.actualmember?.id === this.loggedinuser?.id) {
      
      const control = this.form.get('currentPassword');
      control.addValidators(Validators.required);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  memberSelected(memberid) {
    this.id = Number(memberid);
    this.viewmembersearch = false;
    this.memberService.getMemberById(this.id).subscribe(data => {
      this.actualmember = { id: this.id, givenname: data.givenName, familyname: data.familyName, email: data.email };
    });
  }

  changePassword() {
    this.changepassword = true;
    if (this.actualmember.id === this.loggedinuser.id) {
      // Byt eget lösenord
      this.subscriptions.push(this.userService.changeOwnPasswordAsync(this.form.value).subscribe(data => {
        if (data.status === 200) {
          /*this.dialogService.confirmDialog('Lösenordet ändrat. Du kommer loggas ut.', '', true);
          if (this.form.get('email').value) {
            this.sendEmail();
          }*/
         if (this.form.get('email').value) {
            this.sendEmail();
          }
          this.displayInfoDialog = true;
        }
      }));
    } else {
      // Byt lösenord för annan
      const data = {
        memberId: this.actualmember.id,
        passwords: {
          password: this.form.get('password').value,
          passwordConfirmation: this.form.get('passwordConfirmation').value
        }
      };

      this.subscriptions.push(this.userService.changeMemberPasswordAsync(data).subscribe(resp => {
        if (resp.status === 200) {
          // tslint:disable-next-line:max-line-length
          this.snackbarService.openSnackBar('Lösenordet bytt för ' + this.actualmember.givenname + ' ' + this.actualmember.familyname, null);
          if (this.form.get('email').value) {
            this.sendEmail();
          }
          this.router.navigate(['']);

        }
      }));
    }
  }

  logoffAndRevokeTokens(): void {
    this.oidcSecurityService
      .logoffAndRevokeTokens()
      .subscribe((result) => console.log(result));
  }

    infoDialog(event: Event) {
    this.displayCancelDialog = true;
        this.confirmationService.confirm({
            target: event.target as EventTarget,
            message: 'Vill du avbryta utan att spara ändringarna ?',
            header: 'Spara nytt lösenord',
            closable: true,
            closeOnEscape: true,
            rejectButtonProps: {
                label: 'Nej',
                outlined: true,
                severity: 'secondary'
            },
            acceptButtonProps: {
                label: 'Ja',
                severity: 'secondary'
            },
            accept: () => {
                this.messageService.add({ severity: 'info', summary: 'Bekräftelse', detail: 'Ingen ändring av lösenord har skett.' });
                 this.router.navigate(['']);
                 this.displayCancelDialog = false;
            },
            reject: () => {
                 this.displayCancelDialog = false;
            },
        });
}

  setEmail(evt, element) {
    if (element.checked) {
      this.showemail = true;
    } else {
      this.showemail = false;
    }
  }

  sendEmail() {
    const message = 'Här kommer din kontoinformation i SVOMS:<br><br>' +
      '<b>Namn:</b> ' + this.actualmember?.givenname + ' ' + this.actualmember?.familyname + '<br>' +
      '<b>Medlemsnummer:</b> ' + this.actualmember?.id + '<br><br>' +
      '<b>Användarnamn:</b> ' + this.actualmember?.id + '<br>' +
      '<b>Lösenord:</b> ' + this.form.get('password').value + '<br>';
    const formData = new FormData();
    formData.append('toAddresses', this.actualmember.email);

    formData.append('subject', 'SVOMS - Kontoinformation');
    formData.append('message', message);
    formData.append('to', this.actualmember?.email);
    this.mailService.SendEMail(formData).subscribe(response => {
      if (response) {
        this.snackbarService.openSnackBar('Epost skickat.', null);
       // this.cancel();
      }
    });
  }

  getRandomizedPassword() {
    this.subscriptions.push(this.userService.getRandomizedPassword().subscribe(data => {
      this.form.get('password').setValue(data);
      this.form.get('passwordConfirmation').setValue(data);
    }));
  }

   cancel(event: Event) {
    this.displayCancelDialog = true;
        this.confirmationService.confirm({
            target: event.target as EventTarget,
            message: 'Vill du avbryta utan att spara ändringarna ?',
            header: 'Spara nytt lösenord',
            closable: true,
            closeOnEscape: true,
            rejectButtonProps: {
                label: 'Nej',
                outlined: true,
                severity: 'secondary'
            },
            acceptButtonProps: {
                label: 'Ja',
                severity: 'secondary'
            },
            accept: () => {
                this.messageService.add({ severity: 'info', summary: 'Bekräftelse', detail: 'Ingen ändring av lösenord har skett.' });
                 this.router.navigate(['']);
                 this.displayCancelDialog = false;
            },
            reject: () => {
                 this.displayCancelDialog = false;
            },
        });
}
}